import { render } from "./career.vue?vue&type=template&id=229be681&scoped=true"
import script from "./career.vue?vue&type=script&lang=js"
export * from "./career.vue?vue&type=script&lang=js"

import "./career.vue?vue&type=style&index=0&id=229be681&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-229be681"

export default script